import { getUsersByIds } from './GetUsersByIds';
import { getInternalUsers } from './GetInternalUsers';
import { getInternalUserMe } from './GetInternalUserMe';
import { getInternalUsersByRole } from './GetInternalUsersByRole';
import { getRecruiters } from './GetRecruiters';
import { getChildOffices } from './GetChildOffices';

/**
 * Users Service
 * Provides business logic layer for users operations
 */
export const UsersService = {
  getUsersByIds,
  getInternalUsers,
  getInternalUserMe,
  getInternalUsersByRole,
  getRecruiters,
  getChildOffices,
};
